module.exports = __webpack_public_path__ + "static/Portrait-Medium-96142d2708aeea25bef5b360fc03d843.woff";